export const events = {
  visitProductUpdatesPage: 'Visits product updates page',
  visitProductUpdatesDetailPage: 'Visits product updates detail page',
  goToProductUpdatesPage: 'Go to product updates page',
  goToProductUpdatesDetailPage: 'Go to product updates detail page',
  clickProductUpdateCTA: 'Clicked on product update CTA',
  clickExternalButton: 'Clicked product update external button',
  subscribeToProductUpdate: 'Subscribe to product update',
  unsubscribeFromProductUpdate: 'Unsubscribe from product update',
  shareProductUpdate: 'Shares a product update',
  opensProductUpdatesModal: 'Opens share product update modal',
  clickImageProductUpdate: 'Clicks on image product update',
  viewUpdatesWithCEO: 'View updates with CEO',
  viewUpdatesWithCEOBanner: 'View updates with CEO banner',
  viewProductUpdatesFeaturedBanner: 'View product updates featured banner',
  openProductUpdatesDropdown: 'Open product updates dropdown',
  seeProductUpdatesDropdown: 'See product updates dropdown',
  clickProductUpdatesBenefitsBanner: 'Click product updates benefits banner',
  viewOneEventLink: 'View one event link',
  clickOneEventLink: 'Click one event link',
  dismissOneEventLink: 'Dismiss one event link',
  viewLaunchesWithCEO: 'View launches with CEO',
  clickViewAllProductUpdates: 'Click view all product updates',
}
